import React, { Component } from "react";
import { setMenuTopIndex, setMenuLeftContent, setMenuLeftIndex } from "./../../../redux/actions/menuActions";
import connect from "react-redux/es/connect/connect";
import Services from "./Services";
import MenuAdmin from "../Menu";

class Home extends Component {
  componentDidMount() {
    this.props.setMenuTopIndex("admin");
    this.props.setMenuLeftContent(MenuAdmin);
    this.props.setMenuLeftIndex("services");
  }

  render() {
    return <Services {...this.props} />;
  }
  S;
}
const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setMenuLeftContent: data => {
      dispatch(setMenuLeftContent(data));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// src/pages/admin/services/Services.home.js